import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {    
    async uploadTeamLogo(imageData) {
        try
        {            
            const response = await axios.post(`Upload/backgrounds`, {
                imageData
            });
            
            return response;
        }
        catch (error)
        {
            console.log('uploadTeamLogo error')
            throw error
        }
    },
    async uploadAvatarBase64String(data) {
        try
        {            
            const response = await axios.post(`Image/upload/avatar/base64`, {
                image: data
            });
            
            return response;
        }
        catch (error)
        {
            console.log('uploadTeamLogo error')
            throw error
        }
    },

    //not used, image is already included in clock-in/out payload
    async uploadAttendancePic(data) {
        try
        {            
            const response = await axios.post(`Image/upload/attendance/pic`, {
                image: data
            },
            {
                headers: {
                    'page_key': pageKeys.my_attendance
                }
            })
            
            return response;
        }
        catch (error)
        {
            console.log('uploadTeamLogo error')
            throw error
        }
    },
   
}